<template>
  <v-btn icon variant="flat" class="theme-toggle" @click="settings.toggleTheme">
    <v-icon>
      {{
        settings.theme === "dark" ? "mdi-weather-night" : "mdi-weather-sunny"
      }}
    </v-icon>
  </v-btn>
</template>

<script setup>
import { useSettingsStore } from "@/stores/settings";
const settings = useSettingsStore();
</script>
<style scoped>
.theme-toggle {
  background-color: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
}
</style>
